import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import moment from 'moment';
//Components
import TextField from '../../../../components/TextField/TextField';
//Api
import rotaColeta_api from '../../../../api/rotaColeta_api';
import escalaOperadorColeta_api from '../../../../api/escalaOperadorColeta_api';
import programacaoColeta_api from '../../../../api/programacaoColeta_api';
//Helpers
import { showMessage } from '../../../../helpers/message';
import { validarCampos, objCampo } from '../../../../helpers/ValidadorDeCampos';

export default function IdentificacaoRota({ campos = [], errors, setErrors, ordemColeta, setOrdemColeta }) {
    //Estado das opções do select de veiculos
    const [optionsVeiculos, setOptionsVeiculos] = useState([
        { text: "Selecione", value: "" },
    ]);
    //Estado que guarda as opções de motoristas
    const [optionsMotoristas, setOptionsMotoristas] = useState([]);
    //Estado das opções do select de destinos
    const [optionsDestinos, setOptionsDestinos] = useState([{ text: "Selecione", value: "" }]);

    //CE-3735: o destino gravado na ordem sumiu da lista de disponíveis. A lista não informa o
    //motivo, então a mensagem não afirma a causa: além de licença vencida ou cadastro inativo,
    //o destino sai da lista quando não aceita os resíduos do veículo selecionado.
    const [destinoIndisponivel, setDestinoIndisponivel] = useState(false);

    //Carrega os destinos de acordo com o veiculo selecionado
    const loadDestinos = (idVeiculo) => {
        rotaColeta_api.GetDestinosDisponiveisPorVeiculo(idVeiculo).then(response => {
            setDestinoIndisponivel(!!ordemColeta.tbDestinos_Id
                && !response.data.some(value => value.id.toString() === ordemColeta.tbDestinos_Id.toString()));

            response.data = response.data.map(value => {
                return { value: value.id, text: value.fantasia }
            })
            setOptionsDestinos([{ text: "Selecione", value: "" }, ...response.data]);

        }).catch(e => showMessage("Aviso", e.message, "error", null));
    }

    //Carrega as opções de destinos e veiculos assim que a tela é iniciada
    useEffect(() => {
        programacaoColeta_api.GetVeiculosDisponiveis(ordemColeta.id).then(response => {
            //Confere se o veiculo que foi passado pela ordem não programada esta livre
            if (response.data.filter(v => v.id == ordemColeta.tbVeiculos_Id).length === 0) {
                setOrdemColeta({
                    ...ordemColeta,
                    tbVeiculos_Id: "",
                    tbDestinos_Id: ""
                })
            } else {
                loadDestinos(ordemColeta.tbVeiculos_Id);
            }
            response.data = response.data.map(value => {
                return { text: value.placa, value: value.id }
            })
            setOptionsVeiculos([...optionsVeiculos, ...response.data]);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        })

        //Carrega os motoristas disponiveis
        programacaoColeta_api.GetMotoristasDisponiveis(ordemColeta.id).then(response => {
            let _operadores = [{ text: "Selecione", value: "" }, ...response.data.map(m => { return { text: m.nome, value: m.id.toString() } })];
            if (ordemColeta.tbUsuarios_Operador_Id &&  _operadores.some(o => o.value == ordemColeta.tbUsuarios_Operador_Id)) {
                setOrdemColeta({
                    ...ordemColeta,
                    motorista: _operadores.filter(o => o.value == ordemColeta.tbUsuarios_Operador_Id)[0].text
                })
            }
            setOptionsMotoristas(_operadores);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        });
    }, []);
    //Change para o select de motorista
    const onChangeMotorista = (e) => {
        const { name, value } = e.target;
        const _ordemColeta = {
            ...ordemColeta,
            [name]: value,
            motorista: value != "" ? optionsMotoristas.filter(o => o.value == value)[0].text : ""
        };
        const campo = campos.filter(campo => campo.name === name);
        const _errors = validarCampos(_ordemColeta, campo);
        if (_errors[1].length > 0) {
            setErrors({ ...errors, ..._errors[0] })
        } else {
            const novosErrors = { ...errors };
            delete novosErrors[name];
            setErrors(novosErrors);
        }

        setOrdemColeta(_ordemColeta);
    }

    //OnChange para o select de veiculo
    const onChangeVeiculo = (e) => {
        const { name, value } = e.target;
        const [veiculo] = optionsVeiculos.filter(v => v.value === parseInt(value));
        const _ordemColeta = {
            ...ordemColeta,
            [name]: value,
            tbVeiculos_Placa: veiculo.text,
            tbDestinos_Id: "",
        }
        const campo = campos.filter(campo => campo.name === name);
        const _errors = validarCampos(_ordemColeta, campo);
        if (_errors[1].length > 0) {
            setErrors({ ...errors, ..._errors[0] })
        } else {
            const novosErrors = { ...errors };
            delete novosErrors[name];
            setErrors(novosErrors);
        }
        if (value != "") {
            loadDestinos(value);
        }
        setOrdemColeta(_ordemColeta);
    }
    //OnChange para o select de destino
    const onChangeDestino = (e) => {
        const { name, value } = e.target;
        const [destino] = optionsDestinos.filter(d => d.value === parseInt(value));
        const _ordemColeta = {
            ...ordemColeta,
            [name]: value,
            tbDestinos_Fantasia: destino.text
        }
        const campo = campos.filter(campo => campo.name === name);

        const _errors = validarCampos(_ordemColeta, campo);
        if (_errors[1].length > 0) {
            setErrors({ ...errors, ..._errors[0] })
        } else {
            const novosErrors = { ...errors };
            delete novosErrors[name];
            setErrors(novosErrors);
        }

        setOrdemColeta(_ordemColeta);
    }
    return (
        <div>
            <Row>
                <Col md="12" lg="4">
                    <TextField label={"* Descrição"} maxLength={"300"} name={'descricao'} value={ordemColeta.descricao} disabled={true} invalid={errors.descricao ? true : false} />
                </Col>
                <Col md="12" lg="4">
                    <TextField disabled={ordemColeta.status != "Programada" && ordemColeta.status != "Não Programada"} label={"* Veículo"} onChange={onChangeVeiculo} name={'tbVeiculos_Id'} type={"select"} options={optionsVeiculos} value={ordemColeta.tbVeiculos_Id} invalid={errors.tbVeiculos_Id ? true : false} />
                </Col>
                <Col md="12" lg="4">
                    <TextField disabled={ordemColeta.status != "Programada" && ordemColeta.status != "Não Programada"} label={"Motorista"} name={"tbUsuarios_Operador_Id"} type={"select"} options={optionsMotoristas} value={ordemColeta.tbUsuarios_Operador_Id} invalid={errors.tbUsuarios_Operador_Id ? true : false} onChange={onChangeMotorista} />
                </Col>

                <Col md="12" lg="4">
                    <TextField disabled={ordemColeta.status != "Programada" && ordemColeta.status != "Não Programada"} label={"* Destino"} onChange={onChangeDestino} name={'tbDestinos_Id'} type={"select"} options={optionsDestinos} value={ordemColeta.tbDestinos_Id} invalid={errors.tbDestinos_Id ? true : false} />
                    {destinoIndisponivel &&
                        <span className='text-danger d-block'>
                            O Destino Final desta ordem não está mais disponível para o veículo selecionado — a licença de operação pode estar vencida, o cadastro inativo ou o destino não aceita os resíduos do veículo. Selecione outro destino para prosseguir.
                        </span>
                    }
                </Col>

                <Col md="12" lg="4">
                    <TextField label={"Data"} type={"date"} value={ordemColeta.dataColeta} disabled />
                </Col>
                <Col md="12" lg="4">
                    <TextField label={"Status"} value={ordemColeta.status} disabled />
                </Col>

            </Row>
        </div>
    )
}